import { IInferIntent, IPolicySet, IPolicySetGroup } from '@tymely/atoms';
import {
    INTENTS_BOTTOM_CATEGORIES,
    INTENTS_DEFAULT_CATEGORY,
    INTENTS_DEPRECATED_CATEGORIES,
    INTENTS_TOP_CATEGORIES,
    INTENTS_TOP_INFERRED_CATEGORY,
    NEITHER_LOGIC_BOX_ID,
} from '@tymely/config';
import groupBy from 'lodash/groupBy';

export const searchIntent = (intents: IPolicySet[], searchTerm: string) => {
    if (!searchTerm.trimStart()) {
        return intents;
    }

    const reg = new RegExp(`\\b${searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').trimStart()}\\w*`, 'gi');

    return intents.filter(
        (intent) =>
            intent.category === INTENTS_DEFAULT_CATEGORY ||
            intent.name.concat(intent.id.toString()).match(reg) ||
            intent.category.match(reg) ||
            intent.id.toString().match(reg),
    );
};

export const addProposedIntents = (policySets: IPolicySet[], inferredIntents?: IInferIntent[]) => {
    return policySets.reduce<IPolicySet[]>((acc, policySet) => {
        acc.push(policySet);

        const inferIntent = inferredIntents?.find(
            ({ intent_id }) => intent_id === policySet.id && intent_id !== NEITHER_LOGIC_BOX_ID,
        );

        if (inferIntent) {
            acc.push({
                ...policySet,
                category: INTENTS_TOP_INFERRED_CATEGORY,
                weight: inferIntent.weight || 0,
            });
        }

        return acc;
    }, []);
};

export const categoryOrderIndex = (category: string) => {
    let index = INTENTS_TOP_CATEGORIES.findIndex((c) => c.toLowerCase() === category);
    if (index !== -1) {
        return `@${category}`;
    }
    index = INTENTS_BOTTOM_CATEGORIES.findIndex((c) => c.toLowerCase() === category);
    if (index !== -1) {
        return `~${category}`;
    }
    return category;
};

export const sortGroupedIntents = (groupedIntents: IPolicySetGroup[]) =>
    groupedIntents.sort(({ category: categoryA }, { category: categoryB }) => {
        const sortStringA = categoryOrderIndex(categoryA.toLowerCase());
        const sortStringB = categoryOrderIndex(categoryB.toLowerCase());

        if (sortStringA < sortStringB) return -1;
        if (sortStringA > sortStringB) return 1;
        return 0;
    });

export function groupAndSortIntents(intents: IPolicySet[]): IPolicySetGroup[] {
    const grouped = groupBy(intents || [], (intent) => intent.category.toLowerCase());
    const groupedIntents = Object.entries(grouped)
        .map(([category, categoryIntents]) => ({
            category,
            intents: categoryIntents.sort(({ weight: w1 = 0 }, { weight: w2 = 0 }) => w2 - w1),
        }))
        .filter(({ category }) => !INTENTS_DEPRECATED_CATEGORIES.find((c) => c.toLowerCase() === category));
    return sortGroupedIntents(groupedIntents);
}
